import React from 'react';
import map from 'lodash/map';
import toString from 'lodash/toString';

import ImagesCell from 'shared-components/ImagesCell/ImagesCell';
import styles from './AdminTable.module.css';

const AdminTableRow = ({
  model,
  row,
  rowId,
  imagesOpen,
  imagesFieldName,
  setImagesOpen,
  onClickEdit,
  hasActions,
}) => (
  <tr>
    {map(model, (col) => {
      const { key } = col;
      switch (key) {
        // renders ImagesCell when key is imagesFieldName (eg. "imageUrl")
        case imagesFieldName:
          return (
            <td key={key}>
              <ImagesCell
                images={row[key]}
                rowId={rowId}
                type={key}
                imagesOpen={imagesOpen}
                isEditingRow={false}
                openTooltip={() => setImagesOpen(`${rowId}-${key}`)}
                closeTooltip={() => setImagesOpen(null)}
              />
            </td>
          );
        default:
          // renders a td element
          return (
            <td key={key} className={styles.rowText}>
              {toString(row[key])}
            </td>
          );
      }
    })}
    {/* Actions column */}
    {hasActions && (
      <td className={styles.actionsContainer}>
        <button
          type="button"
          className={`naked-button ${styles.actionButton}`}
          disabled={false}
          onClick={() => onClickEdit && onClickEdit(rowId)}
        >
          <i className="far fa-edit" />
        </button>
      </td>
    )}
  </tr>
);

export default AdminTableRow;
